export function formatJson(json: string) {
  try {
    return JSON.parse(json);
  } catch (error) {
    return json;
  }
}